import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class CalendarService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getTaskMeetingsOfaMonth(date: any) {
    const link = this.apiUrl + ApiUrls.getTasksMeetings + '/' + date;
    return this.http.get(link);
  }

  sendTasksToUsers(body: any) {
    const link = this.apiUrl + ApiUrls.sendTasks;
    return this.http.post<any>(link, body);
  }

  GetSharedRecDetails(id: any) {
    const link = this.apiUrl + ApiUrls.sharedUserRec + '/' + id;
    return this.http.get<any>(link);
  }

  deleteTaskAccess(body: any) {
    const link = this.apiUrl + ApiUrls.deleteRecommendation;
    return this.http.post<any>(link, body);
  }

  updateRecommendationStatus(body: any) {
    const link = this.apiUrl + ApiUrls.updateRecommenation;
    return this.http.post<any>(link, body);
  }
}
